<template>
  <div class="success" v-if="show">
    <div class="con">
      {{msg}}
    </div>
  </div>
</template>

<script>
    export default{
      props: {
        show: Boolean,
        msg: String
      }
    };
</script>

<style lang="scss" scoped="" type="text/css">
  .success{position: fixed;left: 0;right: 0;bottom: 0;top: 0;background: rgba(0,0,0,0.5);
    .con{position: absolute; width: 460px;height: 160px;line-height: 160px;font-size: 16px;text-indent: 190px;color: #333;-webkit-border-radius: 3px;-moz-border-radius: 3px;border-radius: 3px;top: 50%;left: 50%;margin-left: -230px;margin-top: -93px;background:#fff url("../../img/icon8.png") 100px center no-repeat;}
  }
</style>



// WEBPACK FOOTER //
// successalert.vue?3d05b908